import { useEffect, useRef } from "react"

import useAxios from "./useAxios"

export default function useServerPing(interval = 30000) {
  const axios = useAxios()
  const intervalRef = useRef<NodeJS.Timeout | null>()

  const axiosRef = useRef(axios)

  // Keep refs updated
  useEffect(() => {
    axiosRef.current = axios
  }, [axios])

  useEffect(() => {
    const pingServer = async () => {
      try {
        await axios.get("/student/ping")
        // console.log("Server ping successful at", new Date().toLocaleString())
      } catch {
        // console.error("Server ping failed:", error)
      }
    }

    const startInterval = () => {
      // Clear any existing interval first
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
      // Start new interval
      intervalRef.current = setInterval(pingServer, interval)
    }

    const stopInterval = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        // console.log("Tab visible - resuming pings")
        pingServer() // Immediate ping when tab becomes visible
        startInterval()
      } else {
        // console.log("Tab hidden - pausing pings")
        stopInterval()
      }
    }

    // Add event listener
    document.addEventListener("visibilitychange", handleVisibilityChange)

    // Initial ping and start interval
    pingServer()
    startInterval()

    // Cleanup
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      stopInterval()
    }
  }, [interval])
}
